import React from "react";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import alexWebp600 from "../static/images/alex_rodriguez-600.webp";
import alexWebp440 from "../static/images/alex_rodriguez-440.webp";
import alexJpg600 from "../static/images/alex_rodriguez-600.jpg";
import alexJpg440 from "../static/images/alex_rodriguez-440.jpg";

export default function About() {
  return (
    <section className="about" id="about">
      <div className="section__container">
        <div className="section__header">
          <span className="section__index">01</span>
          <div>
            <span className="section__tag">Profile / About</span>
            <h2 className="section__title">Engineering with a product mindset.</h2>
          </div>
        </div>
        <div className="about__content">
          <div className="about__image">
            <div className="about__image-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${alexWebp440} 440w, ${alexWebp600} 600w`}
                  sizes="(max-width: 820px) 220px, 300px"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${alexJpg440} 440w, ${alexJpg600} 600w`}
                  sizes="(max-width: 820px) 220px, 300px"
                />
                <img
                  src={alexJpg600}
                  alt="Alex Rodriguez"
                  width={600}
                  height={800}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
              <div className="about__image-border"></div>
            </div>
          </div>
          <div className="about__info">
            <p className="about__lead">
              I bridge thoughtful interface design and reliable backend engineering
              to build products people can trust.
            </p>
            <p className="about__bio">
              Full-stack developer based in Augsburg, Germany, passionate about building
              clean, performant, and scalable web applications. Since joining CHECK24
              Vergleichsportal Mietwagen GmbH in September 2022, I've grown from a
              frontend specialist into a full-stack developer working within a
              high-traffic enterprise environment — shipping real features used by
              thousands of users every day.
            </p>
            <p className="about__bio">
              Working at enterprise scale has sharpened my skills across the entire
              stack: from building robust PHP backends with Laminas and Symfony, to
              containerizing services with Docker, maintaining CI/CD pipelines via
              Bitbucket Pipelines, and collaborating in agile Scrum teams with a strong
              focus on code quality and best practices. I thrive where clean
              architecture meets great user experience.
            </p>
            <div className="about__details">
              <div className="about__detail">
                <FiMapPin />
                <span>Augsburg, Germany</span>
              </div>
              <div className="about__detail">
                <FiPhone />
                <span>+49 163 3833515</span>
              </div>
              <div className="about__detail">
                <FiMail />
                <span>contact@alexrodriguezvera.com</span>
              </div>
            </div>
            <div className="about__principles">
              <div>
                <span>01</span>
                <strong>Clarity over complexity</strong>
              </div>
              <div>
                <span>02</span>
                <strong>Built to evolve</strong>
              </div>
              <div>
                <span>03</span>
                <strong>People before pixels</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
